import { Dialog, Transition } from "@headlessui/react"
import { useDispatch, useSelector } from "react-redux"
import { VscChromeClose } from "react-icons/vsc"
import { useEffect, useState } from "react"
import { getPaymentInstructions } from "./Api"
import { handleAxiosNetworkError, handleResponse200 } from "../../utils/HttpUtils"
import { notifyError } from "../../utils/Notification"
import { RiLoader5Fill } from "react-icons/ri"

const PaymentInstructionDialog = ({
  selectedData,
  onClose,
}) => {

  const { screenSize } = useSelector(state => state.global)
  
  const [isLoading, setIsLoading] = useState(false)

  const [instructions, setInstructions] = useState([])

  useEffect(() => {
    setIsLoading(true)

    getPaymentInstructions(selectedData.idTransaction)
      .then(res => {
        handleResponse200({
          httpResponse: res,
          onSuccess: payload => {
            setInstructions(payload)
          },
          onRecovFailure: errors => errors.forEach(err => {
              notifyError(err)
          }),
          onUnAuth: error => {
              
          },
          onTechnicalError: errors => errors.forEach(err => {
              notifyError(err)
          })
        })
      })
      .catch(handleAxiosNetworkError)
      .finally(() => {
        setIsLoading(false)
      })
  }, [])

  const Box = ({ instruction }) => {
    return (
      <div>
        <div 
            className='font-bold uppercase p-2 rounded-md shadow-lg border bg-blue-600 text-white' 
            style={{ fontFamily: 'Nunito' }}
        >
          Via {instruction.title}
        </div>
        <div className='pl-5 pt-2'>
          <ul className='list-decimal'>
            { instruction.steps.map(s => (
                <li className='py-1' style={{ fontSize: '15px' }} >{s}</li>
            )) }
          </ul>
        </div>
      </div>
    )
  }

  return (
    <Transition
      appear
      show={true}
    >
      <Dialog
        as="div"
        className="fixed inset-0 overflow-y-auto"
        style={{
          zIndex: "10"
        }}
        onClose={onClose}
      >
        <div className="min-h-screen px-4 text-center flex justify-center items-center">
          <Transition.Child
            enter="ease-out duration-100"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-opacity-70 bg-black" />
          </Transition.Child>

          <Transition.Child
            // enter="ease-out duration-100"
            // enterFrom=""
            // enterTo=""
            // leave="ease-in duration-100"
            // leaveFrom=""
            // leaveTo=""
          >
            <div
              className={
                "absolute " +
                (screenSize.width > 500 ? " left-1/2 top-0 " : " left-0 top-0 ")
              }
            >
              <div
                className="py-1 my-8 text-left align-middle transition-all transform bg-white shadow-xl rounded-lg"
                style={{
                  position: "absolute",
                  left: screenSize.width > 500 ? "-230px" : "0",
                  width: screenSize.width > 500 ? "460px" : screenSize.width + "px"
                }}
              >
                <Dialog.Title
                  as="h3"
                  className="px-2 text-lg flex items-center justify-between font-medium leading-6 text-gray-900 border-b border-gray-200"
                >
                  <button
                    className="p-2 hover:text-red-500 outline-none"
                    onClick={onClose}
                  >
                    <VscChromeClose className="h-6 w-6" />
                  </button>
                </Dialog.Title>
                <div
                  className="mt-4 mb-2 px-5 flex flex-col space-y-3 overflow-auto space-y-5"
                >
                  <div
                    className="overflow-y-auto space-y-5"
                    style={{
                      height: '400px'
                    }}
                  >
                    {
                      isLoading ?
                        (
                          <div className="h-full flex justify-center items-center">
                            <RiLoader5Fill className="h-10 w-10 animate-spin"/>
                          </div>
                        )
                        :
                        instructions.map(i => (
                          <Box instruction={i}/>
                        ))
                    }
                  </div>
                  <div className="py-2 flex justify-center space-x-5">
                    <button
                      className="rounded-full py-1 px-8 bg-red-500 hover:bg-red-700 text-white"
                      onClick={onClose}
                    >
                      Tutup
                    </button>
                  </div>

                </div>

              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  )  

}

export default PaymentInstructionDialog;